import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import {
  Navbar,
  About,
  MyCarousel,
  VideoCarousel,
  PartnerSection,
  Contact,
  Hero,
  LiveChat,
  FairPlaza,
  Ourmission,
  InstagramEmbed,
  ProductGallery,
  StarsCanvas,
  
  SocialLinks,
  Footer,
 
  VerifyEmail,
} from './components';

const App = () => {
  return (
    <Router>
      <div className='relative z-0 bg-primary'>
        <div className='bg-hero-pattern bg-cover bg-no-repeat bg-center'>
          <Navbar />
          <Hero />
        </div>
        <About />
              <MyCarousel />
        <VideoCarousel/>
        <PartnerSection/>
        <FairPlaza />
        <Ourmission />
        <InstagramEmbed/>
        <ProductGallery />
    
        <SocialLinks/>
        <VerifyEmail/>
        <LiveChat/>
        <div className='relative z-0'>
          <Contact/>
          <Footer/>
          <StarsCanvas/>
          
        </div>
      </div>
      
      
    </Router>
  );
};

export default App;
